import script from "./SubmissionCount.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionCount.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionCount.vue?vue&type=style&index=0&id=825eace2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-825eace2"]])

export default __exports__